import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#2B2F33",
  d: "M5.558 6.25a2.442 2.442 0 1 1 2.93 2.393v.863a.488.488 0 1 1-.976 0V8.203c0-.27.218-.488.488-.488A1.465 1.465 0 1 0 6.535 6.25a.488.488 0 1 1-.977 0ZM8.814 11.622a.814.814 0 1 1-1.628 0 .814.814 0 0 1 1.628 0Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#2B2F33",
  "fill-rule": "evenodd",
  d: "M3.05 3.05A6.98 6.98 0 0 1 8 1a6.98 6.98 0 0 1 4.95 2.05A6.98 6.98 0 0 1 15 8a6.98 6.98 0 0 1-2.05 4.95A6.98 6.98 0 0 1 8 15a6.98 6.98 0 0 1-4.95-2.05A6.98 6.98 0 0 1 1 8a6.98 6.98 0 0 1 2.05-4.95ZM8 1.977A6.003 6.003 0 0 0 3.74 3.74 6.003 6.003 0 0 0 1.978 8c0 1.663.673 3.168 1.764 4.26A6.003 6.003 0 0 0 8 14.022a6.003 6.003 0 0 0 4.26-1.764A6.003 6.003 0 0 0 14.022 8a6.003 6.003 0 0 0-1.764-4.26A6.003 6.003 0 0 0 8 1.978Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }